import React, { useState } from "react";

import {
    Drawer,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Collapse,
    Divider,
    Avatar,
    Tooltip,
    IconButton,
    useMediaQuery,
    useTheme,
    Paper,
    makeStyles,
    Button,
    Hidden,
    colors
} from "@material-ui/core";

import {
    Home,
    ShoppingCart,
    ShoppingBasket,
    Assessment,
    People,
    AccountBalance,
    Settings,
    ExpandLess,
    ExpandMore,
    Description,
    MenuBook,
    AccountBalanceWallet,
    Receipt,
    Tune,
    CloudDownload,
    Backup,
    Menu as MenuIcon,
    NotificationsNone,
    Dashboard,
    Language,
    ExitToApp,
    Refresh,
    Store
} from "@material-ui/icons";

import "./SwipStype.css";
import icondrawer from "../../assets/img/apple-icon.png";
import { inshs } from "../../Context/Local";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useTranslation } from 'react-i18next';
import { getLS } from "../../utils/useLS";
import SelectLanguage, { languageOptions } from "../../components/SelectLanguage";
import { useRefresh } from "../../comps/Settings/ReData";
import TimelineIcon from "@material-ui/icons/Timeline";
import HelpIcon from "@material-ui/icons/Help";
import HomeIcon from "@material-ui/icons/Home";
import { Link } from "react-router-dom";
import moment from "moment";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import i18next, { use } from 'i18next';
import { sto } from "../../Context/InshData";
import { insh } from "../../Context/InshSt";
import { insh as inshst } from "../../Context/InshSt";
import { txtA, txtE } from "../../Label/Lbl";
import { col } from "../../Context/inshMt";

export function dateExpire(startDate) {
    const dateStart = moment(startDate);
    const dateNow = moment(new Date()).format("YYYY-MM-DD");

    if (startDate == null)

        return dateNow;
    let sdate = new Date(startDate);
    sdate.setFullYear(sdate.getFullYear() + 1);

    const yyyy = sdate.getFullYear();
    const mm = String(sdate.getMonth() + 1).padStart(2, "0");
    const dd = String(sdate.getDate()).padStart(2, "0");

    return `${yyyy}/${mm}/${dd}`

}
let pScr = getLS("premiScr", {});

const itmes = {
    idata: insh.items,
    front: {
        title: txtA.bascData.items,
        col: col.items,
        show: { rightDown: false },
    },
    setting: {
        tb: {
            wait: true,
            other: true,
            Units: true,
            parms: {
                fltrBranch: true,
                scurrenciestype: "C",
                tname: "curr",
                iempid: sto.empi,
                takei: 20,
                db_name: sto?.db_name
            },
            autos: { Branches: true, Units: true, tax_groups: true },
        },
        screen: "Items",
    },
    style: inshst.bascData.all,
};

const menuItems = [
    {
        id: "home",
        title: "الرئيسية",
        icon: <Home />,
        path: "/"
    },
    {
        id: "sales",
        title: "sales-title",
        icon: <ShoppingCart />,
        color: "#C8F0CB",
        children: [
            { title: "فواتير المبيعات", path: "Invoces", insh: inshs.Sales.sal, disb: pScr.salView, },
            { title: "مرتجعات المبيعات", path: "Invoces", insh: inshs.Sales.salRet, disb: pScr.salRet, },
            { title: "اشعار مدين", path: "Invoces", insh: inshs.Sales.isharDept, disb: pScr.salView, },
            { title: "اشعار دائن", path: "Invoces", insh: inshs.Sales.isharCredit, disb: pScr.salRet, },
            { title: "عروض الأسعار", path: "Invoces", insh: inshs.Sales.salViw, disb: pScr.salView, },
            { title: "فاتورة أولية", path: "Invoces", insh: inshs.Sales.salAwleya, disb: pScr.salView, },
            { title: "closing-invoice", path: "ReportEqfalEveryDay", insh: {}, disb: pScr.eqfDay, },
            { title: "daily-rpt", path: "ReporteveryDay", insh: {}, disb: pScr.evrDay, },
            { title: "close_shifts_report", path: "Shifts", insh: {}, disb: pScr.activ, },

            { title: "active-rpt", path: "Activity", insh: {}, disb: pScr.activ, },
            { title: "sale-tax-rpt", path: "sale-report-tax", insh: {}, disb: pScr.tafseel, },
            { title: "sale-detail-rpt", path: "ReportSalTafsele", insh: {}, disb: pScr.tafseel, },
            { title: "sale-analysis-rpt", path: "ReportSaleAnalysis", insh: {}, disb: pScr.saleAnalysis, },
            // { title: "سندات القبض", path: "/sales/receipts" }
        ]
    },
    {
        id: "purchases",
        title: "purchases-title",
        icon: <ShoppingBasket />,
        // color: colors.blue[100],
        color: "#BBEEEE",
        children: [
            { title: "purchase-invoice", path: "Invoces", insh: inshs.Purches.purch, disb: pScr.purch, },
            { title: "return-purchase", path: "Invoces", insh: inshs.Purches.purchRet, disb: pScr.purchRet, },
            { title: "purchase-order", path: "Invoces", insh: inshs.Purches.purchOrder, disb: pScr.purchRet, },
            { title: "purch-employee", path: "ReportEmpPurches", insh: {}, disb: pScr.activ, },
            { title: "activity-purchase-report", path: "Activityp", insh: {}, disb: pScr.activ, },
            { title: "puchases-details-reprt", path: "PurchaseDetails", insh: {}, disb: pScr.saleAnalysis, },
            { title: "purchases-payment-report", path: "SadadInvoices", insh: inshs.Sales.purchVat, disb: pScr.activ, },
            { title: "puchases-vat-report", path: "sale-report-tax", insh: inshs.Sales.purchVat, disb: pScr.activ, },
            { title: "purch-analysis-rpt", path: "ReportPurchAnalysis", insh: {}, disb: pScr.saleAnalysis, },
        ]
    },
    {
        id: "inventory",
        title: "stores-title",
        icon: <Store />,
        // color: colors.blue[300],
        color: "#DSCCFF",
        children: [
            { title: "store-first-term", path: "Invoces", insh: inshs.Safes.safe, disb: pScr.safe, },
            { title: "str-inv-stat", path: "ReportSafesJard", insh: {}, disb: pScr.safJrd, },
            { title: "str-inv-stat-unit", path: "SafeGrdUnits", insh: {}, disb: pScr.safJrd, },
            { title: "str-adjustment", path: "reStore", insh: {}, disb: pScr.safJrd, },
            { title: "str-item-trans", path: "curr-details-rpt", insh: {}, disb: pScr.safJrd, },
            { title: "totals_movement_item", path: "ItemsTotalMovement", insh: {}, disb: pScr.safJrd, },
            { title: "made_order", path: "Invoces", insh: inshs.Safes.manufacturing, disb: pScr.safe, },
            { title: "str-transfer", path: "StoreTransfer", insh: {}, disb: pScr.safJrd, },
            { title: "str-receipt", path: "ReceiveST", insh: {}, disb: pScr.safJrd, },
            { title: "str-twreed", path: "ItemsTotalMovement", insh: {}, disb: pScr.safJrd, },
            { title: "str-twreed", path: "store-supp", insh: {}, disb: pScr.safJrd, },
            { title: "str-srf", path: "store-exch", insh: {}, disb: pScr.safJrd, },
            { title: "str-turnover", path: "trun-items-avg", insh: {}, disb: pScr.safJrd, },

        ]
    },
    {
        id: "customers",
        title: "customers-and-suppliers-title",
        icon: <People />,
        // color:"#FFC0CB",
        color: "#F0C5F5",
        children: [
            { title: "cust-add", path: "Customers", insh: inshs.Customers[0], disb: pScr.addCust, },
            { title: "sup-add", path: "Customers", insh: inshs.Customers[1], disb: pScr.addCust, },
            { title: "basic-customer-data", path: "SimData", disb: pScr.groupCust, insh: inshs.bascData.Acts, },
            { title: "cust-account", path: "HesabCustA", insh: inshs.Customers[2], disb: pScr.custAcc, },
            { title: "sup-account", path: "HesabCustM", insh: inshs.Customers[3], disb: pScr.custAcc, },
            { title: "cust-balance", path: "BalanceCustRPT", insh: inshs.Customers[4], disb: pScr.custBalance, },
            { title: "cust-last-pay", path: "pay-trans", insh: {}, disb: pScr.custPayTrans, },
            { title: "أعمار الديون", path: "AgelPeriod", insh: inshs.Customers[3], disb: pScr.custPayTrans, }
        ]
    },
    {
        id: "accounts",
        title: "accounts-title",
        icon: <AccountBalance />,
        // color: colors.grey[400],
        color: "#DEDEDE",
        children: [
            { title: "accounts-tree", path: "accounts-index", insh: {}, disb: pScr.accountTree },
            { title: "account-report", path: "ReportAcc", insh: {}, disb: pScr.acc },
            { title: "ext-receipt", path: "ext-receipt", insh: inshs.Accounts.sQKharji, disb: pScr.sandQKh },
            { title: "ext-exchange", path: "ext-exchange", insh: inshs.Accounts.sSKharji, disb: pScr.sandSKh },
            { title: "int-receipt", path: "int-receipt", insh: inshs.Accounts.internalSQ, disb: pScr.sandQD },
            { title: "int-exchange", path: "int-exchange", insh: inshs.Accounts.internalSS, disb: pScr.sandSD },

            { title: "mult-receipt", path: "mult-receipt", insh: {}, disb: pScr.multiQ },
            { title: "mult-exchange", path: "mult-receipt", insh: {}, disb: pScr.multiS },
            { title: "القيود الأفتتاحية", path: "opening-rest", insh: {}, disb: pScr.acc },
            { title: "daily-rest", path: "restInsert", insh: {}, disb: pScr.restInsert },
            { title: "tax-dec", path: "reportTax", insh: {}, disb: pScr.taxRPT },
            { title: "الاقرار الضريبي 2", path: "VatReports", insh: {}, disb: pScr.taxRPT },
            { title: "acc-sys-rpt", path: "MainRBalance", insh: {}, disb: pScr.accountRPT },
            { title: " تحليل مراكز التكلفة", path: "costRpt", insh: {}, disb: pScr.accountRPT },
            { title: "تقرير اليومية العامة", path: "DailyJenral", insh: {}, disb: pScr.accountRPT },
        ]
    },
    {
        id: "basicData",
        title: "basic-information-title",
        icon: <Store />,
        // color: colors.red[300],
        color: "#FFCACA",
        children: [
            { title: "basic-found-data", path: "Foundation", insh: inshs.bascData.Foundation, disb: pScr.found, },
            { title: "basic-product-data", path: "item", insh: itmes, disb: pScr.item, },
            { title: "basic-group-product", path: "groups", insh: inshs.bascData.groups, disb: pScr.itemGroup, },
            { title: "basic-group-tax", path: "SimData", insh: inshs.bascData.tax_groups, disb: pScr.taxGroup, },
            { title: "basic-safe-data", path: "safes", insh: inshs.bascData.Safes, disb: pScr.safes, },
            { title: "basic-stock-data", path: "stocks", insh: inshs.bascData.Stocks, disb: pScr.stocks, },
            { title: "basic-bank-data", path: "banks", insh: inshs.bascData.Banks, disb: pScr.bank, },
            { title: "basic-center-data", path: "costCenters", insh: inshs.bascData.costcenter, disb: pScr.centr, },
            { title: "تعريف المندوبين", path: "salesPerson", insh: {}, disb: pScr.salesmen, },
        ]
    },
    {
        id: "users",
        title: "users-and-permissions-title",
        icon: <People />,
        // color: colors.blue[100],
        color: "#C6E1FF",
        children: [
            { title: "تعريف الموظف", path: "employees", insh: {}, disb: pScr.found, },
            { title: "تعديل بيانات المستخدمين", path: "users-curd", insh: {}, disb: pScr.found, },
            { title: "صلاحيات المستخدمين", path: "user-perms", insh: {}, disb: pScr.found, },
            { title: "تغيير كلمة المرور", path: "change-password", insh: {}, disb: pScr.found, },
            { title: "سلف الموظفين", path: "EmpAdvances", insh: {}, disb: pScr.found, },
            { title: "سند تسليم راتب الموظفين", path: "SalaryPay", insh: {}, disb: pScr.found, },
        ]
    },
    {
        id: "settings",
        title: "system-settings-title",
        icon: <Settings />,
        // color: colors.blue[100],
        color: "#BDF0DC",
        children: [
            { title: "إعدادات الفواتير", path: "casher", insh: {}, disb: true, },
            { title: "large_invoice", path: "invoice-settings-app", insh: {}, disb: true, },
            { title: "الإعدادات الإفتراضية", path: "default_setting", insh: {}, disb: pScr.found, },
            { title: "إعدادات عامة", path: "permissions", insh: {}, disb: pScr.found, },
            { title: "إعداد الميزان الالكتروني", path: "electronic-scale", insh: {}, disb: true, },
            { title: "اعدادات اخرى", path: "Sett", insh: {}, disb: true, },
            // { title:"الإعدادات الإفتراضية", path: "/settings/import" },
            { title: "النسخ الاحتياطي", path: "backup", insh: {}, disb: true, },
            // { title: "الإقفال السنوي", path: "/settings/year-closing" }
        ]
    }
];
const useStyles = makeStyles((theme) => ({
    img: {
        display: "flex",
        "& > *": {
            margin: theme.spacing(1),
        },
    },
    large: {

        height: "20%",
        width: "20%",
    },
    list: {
        width: 250,
    },
    fullList: {
        width: "auto",
    },
    // swip
    appBar: {
        top: "auto",
        bottom: 0,
        borderRadius: "15px 15px 0px 0px",
        backgroundImage: "linear-gradient(to right, #4e9e84 , #2688ba)",
    },
    grow: {
        flexGrow: 1,
    },
    grow2: {
        flexGrow: 0.02,
    },
    grow3: {
        flexGrow: 0.01,
    },
    fabButton: {
        position: "absolute",
        zIndex: 1,
        top: -30,
        left: 0,
        right: 0,
        margin: "0 auto",
    },
    button: {
        margin: theme.spacing(0.5),
        color: "#fff",
        backgroundColor: "#008081",
        boxShadow: "none",
    },
}));

export default function SwipeableNew({ found,
    onNavigate,
    currentPath = "/",
    companyName = "أوراكس سوفت",
    userName = "مدير النظام",
    logo,
}) {
    const theme = useTheme();
    const { t } = useTranslation();
    const { t: transForm } = useTranslation(["forms"]);

    const isMobile = useMediaQuery(
        theme.breakpoints.down("sm")
    );

    const [mobileOpen, setMobileOpen] = useState(false);
    let rr = i18next.language == "ar" ? "right" : "left";
    let dir = i18next.language == "ar" ? "rtl" : "ltr";

    const [expanded, setExpanded] = useState({
        reports: false,
        accounts: false
    });

    const [selected, setSelected] = useState(currentPath);
    const [openInfo, setOpenInfo] = React.useState(false);

    const handleExpand = (id) => {
        setExpanded((prev) => ({
            ...prev,
            [id]: !prev[id]
        }));
    };
    const clickinfoOpen = () => {
        setOpenInfo(true);
    };
    const handleNavigate = (item) => {
        setSelected(item.path);

        if (onNavigate) {
            onNavigate(item.path, item);
        } else {
            window.history.pushState({}, "", item.path);
            window.dispatchEvent(new PopStateEvent("popstate"));
        }

        if (isMobile) {
            setMobileOpen(false);
        }
    };
    let his = useHistory();

    const goScreen = async (path, insh) => {
        his.push({
            pathname: `/${path}`,
            state: insh,
        });
    }

    const renderMenuItem = (item) => {
        const hasChildren =
            Array.isArray(item.children) &&
            item.children.length > 0;

        const isOpen = Boolean(expanded[item.id]);

        const isActive =
            selected === item.path ||
            (hasChildren &&
                item.children.some(
                    (child) => child.path === selected
                ));

        return (
            <React.Fragment key={item.id}>
                <ListItem
                    button
                    style={{ textAlign: rr, backgroundColor: item.color }}
                    onClick={() => {
                        if (hasChildren) {
                            handleExpand(item.id);
                        } else {
                            handleNavigate(item);
                        }
                    }}
                    className={[
                        "sidebar-main-item",
                        isActive ? "sidebar-main-active" : "",
                        isOpen ? "sidebar-main-open" : ""
                    ].join(" ")}
                >
                    <ListItemIcon className="sidebar-main-icon">
                        {item.icon}
                    </ListItemIcon>

                    <ListItemText
                        primary={t(item.title)}
                        primaryTypographyProps={{
                            className: "sidebar-main-text"
                        }}
                    />

                    {hasChildren &&
                        (isOpen ? (
                            <ExpandLess className="sidebar-arrow" />
                        ) : (
                            <ExpandMore className="sidebar-arrow" />
                        ))}
                </ListItem>

                {hasChildren && (
                    <Collapse
                        in={isOpen}
                        timeout="auto"
                        unmountOnExit
                    >
                        <div className="sidebar-submenu">
                            <List disablePadding>
                                {item.children.map((child) => {
                                    const childActive =
                                        selected === child.path;

                                    return (
                                        <ListItem
                                            button
                                            key={child.path}
                                            style={{ textAlign: rr }}
                                            onClick={() =>
                                                // handleNavigate(child)
                                                goScreen(child.path, child.insh)

                                            }
                                            className={[
                                                "sidebar-sub-item",
                                                childActive
                                                    ? "sidebar-sub-active"
                                                    : ""
                                            ].join(" ")}
                                        >
                                            <span className="sidebar-sub-dot" />

                                            <ListItemText
                                                primary={t(child.title)}
                                                primaryTypographyProps={{
                                                    className: "sidebar-sub-text"
                                                }}
                                            />

                                            {childActive && (
                                                <span className="sidebar-active-mark" />
                                            )}
                                        </ListItem>
                                    );
                                })}
                            </List>
                        </div>
                    </Collapse>
                )}
            </React.Fragment>
        );
    };
    const styles = {
        paperContainer: {
            backgroundImage: `url(${icondrawer})`,
            height: "50px",
            boxShadow: "none",
            width: "50px",
            marginLeft: "2rem",
            backgroundSize: "cover",
        },
    };
    const classes = useStyles();
    function refreshPage() {
        his.push({ pathname: "/" });
        window.location.reload(false);
    }

    const locConn = JSON.parse(localStorage.getItem("infoConn")) || {};

    const inshState = {
        server: locConn.server,
        ipinsh: locConn.ipinsh,
        changip: locConn.changip,
        ip: locConn.ip,
        endDigtip: locConn.endDigtip,
        namedb: locConn.namedb,
        id: locConn.id,
        pass: locConn.pass,
        useUri: locConn.useUri,
        port: locConn.port,
        ftp: locConn.ftp,
        typeConnct: locConn.typeConnct,
        mode: locConn.mode,
        leavle: "signIn",
    };

    const refDatas_out = () => {
        localStorage.removeItem("dataShamel");
        let loc = JSON.parse(localStorage.getItem("premiApp"));

        localStorage.setItem("premiApp", JSON.stringify({ ...loc, id: 0 }));
        localStorage.removeItem("DataRem");
    };
    const singout = () => {
        refDatas_out();
        localStorage.setItem("infoConn", JSON.stringify(inshState));
        refreshPage();
    };
    const [lang, setLang] = useState(i18next.language ?? languageOptions[0].lang);

    const drawerContent = (
        <div className="sidebar-root" dir={i18next.language == "ar" ? "ltr" : "rtl"}>

            {/* Logo */}
            <div className="sidebar-brand">


                <div className="sidebar-brand-text">
                    <div className="sidebar-brand-name">
                        {/* {companyName} */}
                        {/* <div> */}
                            <span > {transForm("orax")}</span>
                            <span > {transForm("soft")}</span>
                        {/* </div> */}
                    </div>

                    <div className="sidebar-brand-subtitle">
                        النظام المحاسبي السحابي
                    </div>
                </div>
                <div className="sidebar-logo">
                    <div className={classes.img}>
                        <Paper style={styles.paperContainer}> </Paper>
                    </div>
                </div>
            </div>

            <Divider className="sidebar-divider" />

            {/* قائمة النظام */}
            <div className="sidebar-menu-heading">
                {/* <span>القائمة الرئيسية</span> */}
                <span >{transForm("main-screen")}</span>
            </div>

            <List className="sidebar-menu">
                {menuItems.map(renderMenuItem)}
            </List>

            {/* المساحة السفلية */}
            <div className="sidebar-bottom">

                <div className="sidebar-user" style={{ direction: { dir } }}>
                    <Avatar className="sidebar-user-avatar">
                        {userName.charAt(0)}
                    </Avatar>

                    <div className="sidebar-user-info">
                        <div className="sidebar-user-name">
                            {sto?.usernames}
                        </div>

                        <div className="sidebar-user-role">
                            حساب المستخدم
                        </div>
                    </div>

                    <Tooltip title="تسجيل الخروج">
                        <IconButton
                            size="small"
                            className="sidebar-logout"
                            onClick={() => {
                                if (
                                    window.confirm(
                                        "هل تريد تسجيل الخروج؟"
                                    )
                                ) {
                                    singout()
                                }
                            }}
                        >
                            <ExitToApp />
                        </IconButton>
                    </Tooltip>
                </div>

                <div className="sidebar-language">
                    <button
                        className={lang === "ar" ? "sidebar-language-button" : "sidebar-language-active"}
                        onClick={() => {
                            i18next.changeLanguage('en-US'); setLang('en-US');
                        }}
                    >
                        English
                    </button>
                    <button
                        className={lang === "ar" ? "sidebar-language-active" : "sidebar-language-button"}
                        onClick={() => {
                            i18next.changeLanguage('ar'); setLang('ar');
                        }}
                    >
                        العربية
                    </button>
                </div>

                <div className="sidebar-version">
                    <span className="sidebar-status-dot" />
                    OraxCloud ERP
                </div>
            </div>
        </div>
    );
    const cchart = { color: "#fff" };

    const { fetch, fetching, isError } = useRefresh();
    const [state, setState] = React.useState({ right: false });

    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event &&
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };
    return (
        <>
            <SwipeableDrawer
                anchor={rr}
                open={state[rr]}
                onClose={toggleDrawer(rr, false)}
                onOpen={toggleDrawer(rr, true)}
            >
                {drawerContent}
            </SwipeableDrawer>

            <AppBar position="fixed" color="primary" className={classes.appBar} dir={i18next.language == "ar" ? "ltr" : "rtl"}>
                <Typography style={{ marginRight: "-4px", zIndex: 1301 }}>
                    <Toolbar variant="dense">
                        <Hidden smUp={["sm"]}>
                            <IconButton
                                component={Link}
                                to="/"
                                variant="contained"
                                edge="start"
                                color="inherit"
                                aria-label="home"
                            >
                                <HomeIcon />
                                {"  "}
                            </IconButton>

                            <IconButton
                                onClick={clickinfoOpen}
                                variant="contained"
                                edge="start"
                                color="inherit"
                                aria-label="home"
                            >
                                <HelpIcon style={cchart} />
                                {"  "}
                            </IconButton>
                            <IconButton
                                onClick={() => {
                                    his.push({ pathname: "/chart" });
                                    window.location.reload(false);
                                }}
                                variant="contained"
                                edge="start"
                                color="inherit"
                                aria-label="Dashboard"
                            >
                                <TimelineIcon style={cchart} />
                                {"  "}
                            </IconButton>
                            <IconButton
                                onClick={fetch}
                                variant="contained"
                                edge="start"
                                color="inherit"
                                aria-label="Refresh"
                            >
                                <Refresh style={cchart} />
                                {"  "}
                            </IconButton>
                        </Hidden>

                        <Hidden only={["xs"]}>
                            <Button
                                variant="contained"
                                className={classes.button}
                                component={Link}
                                to="/"
                                color="primary"
                                size="large"
                                startIcon={<HomeIcon />}
                            >
                                {" "}
                                {t("main-menu-title")}
                            </Button>

                            <Button
                                variant="contained"
                                className={classes.button}
                                onClick={clickinfoOpen}
                                color="primary"
                                size="large"
                                startIcon={<HelpIcon />}
                            >
                                {" "}
                                معلومات المستخدم{" "}
                            </Button>
                            <Button
                                variant="contained"
                                className={classes.button}
                                disabled={!pScr.acc}
                                onClick={() => {
                                    his.push({ pathname: "/chart" });
                                    window.location.reload(false);
                                }}
                                color="primary"
                                size="large"
                                startIcon={<TimelineIcon style={cchart} />}
                            >
                                {" "}
                                {/* Dashboard{" "} */}
                            </Button>
                            <Button
                                variant="contained"
                                className={classes.button}
                                disabled={fetching}
                                onClick={fetch}
                                color="primary"
                                size="large"
                                startIcon={<Refresh style={cchart} />}
                            >
                                {/* Refresh{" "} */}
                            </Button>

                            <div>
                                <SelectLanguage />
                            </div>
                            <div className={classes.grow2} />

                            {found?.StartWorkDate &&
                                (
                                    <>
                                        <div className={classes.grow3} style={{ fontWeight: "bold", fontSize: "1rem", color: "#fff", display: "flex", justifyContent: "space-between", direction: "rtl" }} >
                                            {"تاريخ نهاية العقد"} {"  :  "}
                                            <div className={classes.grow3} style={{ fontWeight: "bold", fontSize: "1.1rem", color: "#c62828", }}>
                                                {"  " + dateExpire(found?.StartWorkDate) + "  "}
                                            </div>
                                        </div>
                                        <div className={classes.grow3} style={{ fontWeight: "bold", fontSize: "1rem", color: "#fff", display: "flex", justifyContent: "space-between", direction: "rtl", }} >
                                            {"تاريخ بداية العقد"} {"  :  "}
                                            <div className={classes.grow3} style={{ fontWeight: "bold", fontSize: "1.1rem", color: colors.green[900], marginLeft: "1rem" }}>
                                                {"   " + found?.StartWorkDate + "   "}
                                            </div>
                                        </div>
                                        <div />

                                    </>
                                )}

                        </Hidden>
                        <div className={classes.grow} />


                        <IconButton edge="start" color="inherit" aria-label="open drawer">
                            <MenuIcon onClick={toggleDrawer(rr, true)} />
                        </IconButton>

                    </Toolbar>
                </Typography>
            </AppBar>
        </>
    );
}   